import React, { memo } from 'react';

import { Icon } from '@atlas/ui';

export const ProfitIcons = ({ noneMargin, oddsBust }) => {
  if (!noneMargin && !oddsBust) {
    return null;
  }

  return (
    <div className="profit-icons">
      {oddsBust && (
        <div className="profit-icon boost">
          <Icon height={16} name="boost" width={16} />
        </div>
      )}

      {noneMargin && (
        <div className="profit-icon margin-zero">
          <Icon height={16} name="margin-0" width={16} />
        </div>
      )}
    </div>
  );
};

export default memo(ProfitIcons);
